// Прием платежей через кассу.

import ApiRequest from "../api-request";
import cookies from "../cookies";
import popupsState from "../popups/popups-state";

const CSRF_TOKEN = cookies.get("csrftoken");

function makePayment(
    email,
    amount,
    {
        planName = undefined, quantity = undefined, onError = undefined,
    } = {},
) {
    createPayment(email, amount, planName, quantity)
        .then(resp => {
            if (resp.errors) {
                console.log(resp);
                if ("global" in resp.errors) {
                    popupsState.dispatchOpen({
                        newPopupId: "error_popup",
                        popupData: { errors: [resp.errors.global] },
                    });
                }
                if (onError !== undefined) {
                    onError();
                }
                return;
            }
            location.assign(resp.data.redirect_url);
        });
}

async function createPayment(email, amount, planName, quantity, token = undefined) {
    const url = "/payments/create/";

    if (!amount) {
        return { errors: { global: "Введите число" } };
    }

    const data = {
        email,
        amount,
        source_url: location.href,
        plan_name: planName,
        quantity,
        token,
    };
    const api = new ApiRequest(url, { csrf: CSRF_TOKEN });
    return await api.send(data, false);
}

async function getPayment(id) {
    const url = `/payments/${id}/`;
    const options = { headers: { Accept: "application/json" } };
    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            const err = (data && data.message) || response.status;
            return Promise.reject(err);
        }
        return await response.json();
    } catch (err) {
        return Promise.reject(err);
    }
}

export default {
    create: createPayment,
    get: getPayment,
    make: makePayment,
};
